import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, AlertTriangleIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative min-h-[85vh] flex flex-col items-center justify-center px-4 py-16 overflow-hidden bg-[#0a0a0a]" data-id="element-84">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-amber-900/10 via-[#0a0a0a] to-[#0a0a0a]" data-id="element-85" />
      <div className="absolute inset-0 opacity-20 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] mix-blend-overlay" data-id="element-86" />

      <div className="relative z-10 max-w-3xl mx-auto text-center space-y-6" data-id="element-87">
        {/* Warning Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-500 text-sm font-medium uppercase tracking-wider" data-id="element-88">
          <AlertTriangleIcon className="w-4 h-4" data-id="element-89" />
          <span data-id="element-90">Alerta de Estafa Inmobiliaria</span>
        </motion.div>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-5xl md:text-7xl font-extrabold tracking-tighter text-white leading-[1.1]" data-id="element-91">
          No transfieras <br className="hidden md:block" data-id="element-92" />
          <span className="text-amber-500" data-id="element-93">todavía.</span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-xl md:text-2xl text-zinc-400 font-medium" data-id="element-94">
          Si te apuran, es parte del truco.
        </motion.p>

        {/* Story / Lead */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="bg-zinc-900/50 border-l-4 border-amber-500 p-5 md:p-6 text-left rounded-r-lg max-w-2xl mx-auto backdrop-blur-sm" data-id="element-95">
          <p className="text-zinc-300 text-lg leading-relaxed" data-id="element-96">
            Te escriben:{' '}
            <span className="text-white font-semibold italic" data-id="element-97">
              «Hay otro interesado. Si querés reservar, transferí ahora.»
            </span>
          </p>
          <p className="mt-4 text-zinc-300 text-lg leading-relaxed" data-id="element-98">
            Y vos te quedás con ese nudo en el pecho que no es duda… es
            instinto. Pero igual, por dentro, aparece la trampa mental:{' '}
            <span className="text-white italic" data-id="element-99">
              «¿Y si es real y lo pierdo?»
            </span>
          </p>
          <p className="mt-4 text-zinc-300 text-lg leading-relaxed" data-id="element-100">
            Ahí es donde la gente pierde plata. No porque sea ingenua.
            <span className="text-amber-500 font-semibold" data-id="element-101">
              {' '}
              Porque está apurada, cansada y quiere resolver.
            </span>
          </p>
        </motion.div>

        {/* Promise */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="pt-4" data-id="element-102">
          <p className="text-white text-xl font-medium mb-6" data-id="element-103">
            No necesitás ser más desconfiado. <br data-id="element-104" />
            Necesitás un{' '}
            <span className="text-amber-500 font-bold underline decoration-amber-500/30 underline-offset-4" data-id="element-105">
              protocolo
            </span>
            .
          </p>

          <Button size="lg" className="group text-lg px-10" onClick={() => {
          document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-106">
            Descargá el Kit
            <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-107" />
          </Button>
        </motion.div>
      </div>
    </section>;
}